//进货单API
import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findPurchaseOrder = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/findPurchaseOrder?` + params,
        method: 'GET'
    })
}
export const findSupplyList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/findSupplyList?` + params,
        method: 'GET'
    })
}
export const findPurchaseOrderAll = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/findPurchaseOrder`,
        method: 'GET'
    })
}

export const findAllShopByUserId = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop/findAllShopByUserId/${id}`,
        method: 'GET'
    })
}
export const orderTaking = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/orderTaking`,
        method: 'PUT',
        data: data
    })
}
export const selectShop = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/selectShop`,
        method: 'PUT',
        data: data
    })
}
export const findDepartmentByUserId = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findDepartmentByUserId/${id}`,
        method: 'GET'
    })
}
export const findAllSuperiorDepartment = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
        method: 'GET'
    })
}
export const findGoodsList = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/findGoodsByRootDepartId/${id}`,
        method: 'GET'
    })
}
export const findDistributionSheetDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/findDistributionSheetDetail/${id}`,
        method: 'GET'
    })
}
export const findDistributionSheetDetailSupplyListById = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/distributionSheet/findDistributionSheetDetailSupplyListById/${id}`,
        method: 'GET'
    })
}
export const findPurchaseOrderDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/findCloudSupplyList/${id}`,
        method: 'GET'
    })
}
export const immediatePaySupplyList = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/immediatePaySupplyList/${id}`,
        method: 'GET'
    })
}
export const generateQRCode = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/generateQRCode/${id}`,
        method: 'GET'
    })
}
export const addPurchaseOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/insertCloudSupplyList`,
        method: 'POST',
        data: data
    })
}

export const editPurchaseOrder = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/supplyList/updateCloudSupplyList`,
        method: 'PUT',
        data: data
    })
}